import React, { useState, useRef, useCallback } from 'react'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import userIcon from '../assets/images/user.svg?url'
import ModuleSwitcher from '../containers/ModuleSwitcher'

import AccountSettings from './AccountSettings'
import useOutsideClickListener from 'LegacyUtils/hooks/useOutsideClickListener'

import { logout } from 'Actions/app'
import { canModifyAccountSettings, getCurrentUser } from 'Selectors/users'

const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false)
  const [showAccountSettingsModal, setShowAccountSettingModal] = useState(false)
  const dropdownRef = useRef()
  const dispatch = useDispatch()
  const user = useSelector(getCurrentUser)
  const canModifyAccountSetting = useSelector(canModifyAccountSettings)

  const closeDropdown = useCallback(() => setShowDropdown(false), [setShowDropdown])

  useOutsideClickListener(dropdownRef, closeDropdown, showDropdown)

  const onAccountSettingsClick = (e) => {
    e.preventDefault()
    setShowAccountSettingModal(true)
    setShowDropdown(false)
  }

  const onCloseAccountModal = useCallback(() => {
    setShowAccountSettingModal(false)
  }, [])

  const onDropdownClick = (e) => {
    e.preventDefault()
    setShowDropdown(!showDropdown)
  }

  const onLogout = (e) => {
    e.preventDefault()

    const ok = confirm('Are you sure to logout')
    if (!ok) {
      return
    }

    dispatch(logout())
  }

  const handleOverlay = (overlayState) => {
    setShowOverlay(overlayState)
  }

  return (
    <React.Fragment>
      <div className={classNames('overlay', { shown: showOverlay })} />
      <div className='navbar'>
        <ModuleSwitcher showOverlay={handleOverlay} />
        <div className={classNames('nav-item dropdown', { show: showDropdown })}>
          <a
            className='nav-link dropdown-toggle text-right text-white'
            href='#'
            id='userDropdown'
            role='button'
            aria-haspopup='true'
            onClick={onDropdownClick}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <img src={userIcon} alt={user.name} />
          </a>
          <div
            className={classNames('dropdown-menu dropdown-menu-lg-right', { show: showDropdown })}
            aria-labelledby='userDropdown'
            ref={dropdownRef}
          >
            {canModifyAccountSetting && (
              <a className='dropdown-item' href='#' onClick={onAccountSettingsClick}>
                Account Settings
              </a>
            )}
            <a className='dropdown-item' href='#' onClick={onLogout}>
              Logout
            </a>
          </div>
        </div>
      </div>
      <AccountSettings isOpen={showAccountSettingsModal} hide={onCloseAccountModal} />
    </React.Fragment>
  )
}

export default Navbar
